
import BigBanner from './routes/banner/BigBanner.vue';

import FlowBig from './routes/flow/FlowBig.vue';

import BigExcellence from './routes/excellence/BigExcellence.vue';
import createBigExcellence from './routes/excellence/component/createBigExcellence.vue';
import editBigExcellence from './routes/excellence/component/editBigExcellence.vue';

import BigCustomerList from './routes/customer_list/BigCustomerList.vue';
import detailBigCustomer from './routes/customer_list/component/detailCustomer.vue';

import BigRegistrationButton from './routes/registration_button/BigRegistrationButton.vue';

const PaxelBigRoutes = [
    {
        path: '/paxel-big-banner',
        name: 'BigBanner',
        component: BigBanner,
    },
    {
        path: '/paxel-big-flow',
        name: 'FlowBig',
        component: FlowBig,
    },
    {
        path: '/paxel-big-excellence',
        name: 'BigExcellence',
        component: BigExcellence,
    },
    {
        path: '/create-paxel-big-excellence',
        name: 'createBigExcellence',
        component: createBigExcellence,
    },
    {
        path: '/edit-paxel-big-excellence/:id',
        name: 'editBigExcellence',
        component: editBigExcellence,
    },
    {
        path: '/paxel-big-customer-list',
        name: 'BigCustomerList',
        component: BigCustomerList,
    },
    {
        path: '/detail-customer-paxel-big/:id',
        name: 'detailBigCustomer',
        component: detailBigCustomer,
    },
    {
        path: '/paxel-big-registration-button',
        name: 'BigRegistrationButton',
        component: BigRegistrationButton,
    },
];

export default PaxelBigRoutes;
